import { getMatchedComponents, setScrollRestoration } from './utils';

// Nuxt's default scroll behaviour, with one change: a navigation that only
// changes the query string keeps the scroll position straight away. The default
// waits for a page transition that never comes, then scrolls to the top during
// the next real navigation, which fights the position restored on going back.

if (process.client && 'scrollRestoration' in window.history) {
    setScrollRestoration('manual');

    // Let the browser restore the position across a reload or a return from
    // another site.
    window.addEventListener('beforeunload', () => {
        setScrollRestoration('auto');
    });

    window.addEventListener('load', () => {
        setScrollRestoration('manual');
    });
}

function shouldScrollToTop(route) {
    const Pages = getMatchedComponents(route);

    if (Pages.length === 1) {
        const { options = {} } = Pages[0];

        return options.scrollToTop !== false;
    }

    return Pages.some(({ options }) => options && options.scrollToTop);
}

export default function scrollBehavior(to, from, savedPosition) {
    if (to !== from && to.path === from.path && to.hash === from.hash) {
        return false;
    }

    let position = false;
    const isRouteChanged = to !== from;

    if (savedPosition) {
        position = savedPosition;
    } else if (isRouteChanged && shouldScrollToTop(to)) {
        position = { x: 0, y: 0 };
    }

    const nuxt = window.$nuxt;

    if (!isRouteChanged || (to.path === from.path && to.hash !== from.hash)) {
        nuxt.$nextTick(() => nuxt.$emit('triggerScroll'));
    }

    return new Promise((resolve) => {
        // Wait for the out transition to finish, if there is one.
        nuxt.$once('triggerScroll', () => {
            if (to.hash) {
                const hash = typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined'
                    ? `#${window.CSS.escape(to.hash.substr(1))}`
                    : to.hash;

                try {
                    const element = document.querySelector(hash);

                    if (element) {
                        position = { selector: hash };

                        const y = Number(getComputedStyle(element)['scroll-margin-top'].replace('px', ''));

                        if (y) {
                            position.offset = { y };
                        }
                    }
                } catch (e) {
                    // An invalid selector keeps the coordinates worked out above.
                }
            }

            resolve(position);
        });
    });
}
